<template>
	<div>
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true
			v-model="isFilterShow" :dialog-class="''" :ok-title="'Search'" ok-variant="success" :cancel-title="'Clear'"
			@ok="getWorkOrderSupplys" @hidden="resetModal">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="workOrderProcesss"
							optionsLabel="workOrderProcessNumber" optionsKey="id" label-cols-sm="4" label-cols-lg="3"
							label="Work Order Process Number" id="filter-" size="sm"
							:model.sync="filter.workOrderProcessId" @input="getWorkOrderProcesss"
							@focus="getWorkOrderProcesss" />
						<app-input-textbox id="fieldset-work-order-supply-number" label-cols-sm="4" label-cols-lg="3"
							label="Work Order Supply Number" label-for="filter-work-order-supply-number" size="sm"
							:model.sync="filter.workOrderSupplyNumber" />
						<app-input-datepicker-range id="fieldset-work-order-supply-date" label-cols-sm="4"
							label-cols-lg="3" label="WorkOrderSupplyDate" size="sm"
							:modelFrom.sync="filter.workOrderSupplyDateFrom"
							:modelTo.sync="filter.workOrderSupplyDateTo"
							:date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"
							reset-button />
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-textarea id="fieldset-remark" label-cols-sm="4" label-cols-lg="3" label="Remark"
							label-for="filter-remark" size="sm" :model.sync="filter.remarkMultiple" />
						<app-input-combobox-autocomplete :options="lines" optionsLabel="code" optionsKey="id"
							label-cols-sm="4" label-cols-lg="3" label="Line" id="filter-" size="sm"
							:model.sync="filter.lineId" @input="getLines" @focus="getLines" />
						<app-input-combobox-autocomplete :options="documentStatuss" optionsLabel="name" optionsKey="id"
							label-cols-sm="4" label-cols-lg="3" label="Document Status" id="filter-" size="sm"
							:model.sync="filter.documentStatusId" @input="getDocumentStatuss"
							@focus="getDocumentStatuss" />
					</b-col>
					<b-col cols="12" lg="6">

						<b-button variant="danger" v-if="false" size="sm" class="float-right" @click="resetFilter"><span
								style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear
							Filter</b-button>
						<b-button variant="primary" v-if="false" size="sm" class="float-right mr-1"
							@click="getWorkOrderSupplys"><span style="font-size: 0.75rem"
								class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
					Clear
				</b-button>
				<b-overlay :show="isDataLoading" rounded opacity="0.6" spinner-small spinner-variant="primary"
					class="float-right ">
					<b-button size="sm" class="float-right btn-default" @click="ok()">
						Search
					</b-button>
				</b-overlay>
			</template>
		</b-modal>

		<div>
			<b-row class="mb-2 d-sm-none d-md-flex">
				<b-col class="pt-1">
					<span class="function-title">Work Order Supply</span>
				</b-col>
				<b-col>
					<span class="float-right">
						<b-dropdown text="Action" class="m-md-2 btn-action-more" size="sm" v-if="disableFeature">
							<b-dropdown-item v-if="(userRole != null ? userRole.allowDownload : false)"
								href="files/workordersupply/WorkOrderSupply.xlsx"><b-icon-wallet
									class="mr-1"></b-icon-wallet>
								Download Template</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowUpdate : false)"
								@click="showPopupUploadData"><b-icon-upload class="mr-1"></b-icon-upload> Upload
								Data</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowPrint : false)"
								@click="printData"><b-icon-printer class="mr-1"></b-icon-printer> Export To
								Pdf</b-dropdown-item>
						</b-dropdown>
						<b-overlay v-if="(userRole != null ? userRole.allowCreate : false)" :show="isCreateBusy"
							opacity="0.6" spinner-small spinner-variant="default" class="d-inline">
							<b-button class="btn-create btn-fill-success" @click="createData" size="sm">
								<b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
						</b-overlay>

					</span>
					<Portal to="app-navbar-bottom">
						<span class="float-right">
							<b-overlay v-if="(userRole != null ? userRole.allowCreate : false)" :show="isCreateBusy"
								opacity="0.6" spinner-small spinner-variant="default" class="d-inline">
								<b-button class="btn-create btn-fill-success" @click="createData" size="sm">
									<b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
							</b-overlay>

						</span>
					</Portal>
				</b-col>
			</b-row>
			<div class="table-corner">
				<div class="table-action-button">
					<b-button v-if="disableFeature" class="btn-action d-sm-none d-md-inline" size="sm"
						@click="downloadData"><b-icon-download class="mr-1"></b-icon-download> Download</b-button>

					<b-overlay v-if="isShowDeleteButton" :show="isDeleteBusy" rounded opacity="0.6" spinner-small
						spinner-variant="primary" class="d-inline-block">
						<click-confirm>
							<b-button class="btn-action" @click="deleteMultipleData" size="sm"><b-icon-trash
									class="mr-1"></b-icon-trash> Delete</b-button>
						</click-confirm>
					</b-overlay>

					<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm"
						@click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> {{ 'Advance Filter' |
			countFilter(filter) }} </b-button>
					<span class="d-inline d-md-none">
						<b-button v-if="!isStacked" class="btn-action float-right btn-action-scroll" size="sm"
							@click="isStacked = true"><b-icon-view-stacked></b-icon-view-stacked></b-button>
						<b-button v-else class="btn-action float-right btn-action-scroll" size="sm"
							@click="isStacked = false"><b-icon-table></b-icon-table></b-button>
					</span>
					<span>
						<b-button :disabled="isPullRight" class="btn-action float-right btn-action-scroll" size="sm"
							@click="scrollRight"><b-icon-caret-right-fill></b-icon-caret-right-fill></b-button>
						<b-button :disabled="isPullLeft" class="btn-action float-right btn-action-scroll" size="sm"
							@click="scrollLeft"><b-icon-caret-left-fill></b-icon-caret-left-fill></b-button>
					</span>
				</div>
				<b-table sticky-header="565px" :stacked="isStacked" id="table-list-workordersupply"
					:class="'table-action ' + (isStacked ? '' : 'table-index')" head-variant="head-light"
					:bordered="true" :no-local-sorting="true" :items="workOrderSupplys" :fields="fields"
					:busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive show-empty
					:tbody-tr-class="rowClass">
					<template #empty>
						<app-no-data-image />
					</template>
					<template #table-busy v-if="workOrderSupplys.length <= 0">
						<app-no-data-image :animate="true" />
					</template>
					<template v-slot:head(front-action)>
						<b-button @click="isShowFilter = !isShowFilter" size="sm"
							class="btn-filter float-right"><b-icon-funnel /></b-button>
					</template>
					<template #top-row v-if="isShowFilter">
						<b-th></b-th>
						<b-th></b-th>
						<b-th stacked-heading="Work Order Process Number" class="table-filter">
							<v-select append-to-body label="workOrderProcessNumber" :options="workOrderProcesss"
								:value="filter.workOrderProcessId" :reduce="item => item.id"
								v-model="filter.workOrderProcessId" :filterable="true"
								@input="getWorkOrderSupplysWithoutLoading" @search="getWorkOrderProcesss"></v-select>
						</b-th>
						<b-th stacked-heading="Work Order Supply Number" class="table-filter">
							<b-form-input id="input-work-order-supply-number-table"
								@input="getWorkOrderSupplysWithoutLoading" v-model="filter.workOrderSupplyNumber"
								size="sm"></b-form-input>
						</b-th>
						<b-th stacked-heading="Work Order Supply Number" class="table-filter">
							<b-form-datepicker boundary="viewport" placeholder="" id="input-work-order-supply-date-from-table" reset-button @input="getWorkOrderSupplysWithoutLoading" v-model="filter.workOrderSupplyDateFrom" size="sm" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"></b-form-datepicker>
							<b-form-datepicker boundary="viewport" placeholder="" id="input-work-order-supply-date-to-table" reset-button @input="getWorkOrderSupplysWithoutLoading" v-model="filter.workOrderSupplyDateTo" size="sm" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"></b-form-datepicker>
							
						</b-th>
						<b-th stacked-heading="Remark" class="table-filter">
							<b-form-input id="input-remark-table" @input="getWorkOrderSupplysWithoutLoading"
								v-model="filter.remark" size="sm"></b-form-input>
						</b-th>
						<b-th stacked-heading="Line" class="table-filter">
							<v-select append-to-body label="code" :options="lines" :value="filter.lineId"
								:reduce="item => item.id" v-model="filter.lineId" :filterable="true"
								@input="getWorkOrderSupplysWithoutLoading" @search="getLines"></v-select>
						</b-th>
						<b-th stacked-heading="Document Status" class="table-filter">
							<v-select append-to-body label="name" :options="documentStatuss"
								:value="filter.documentStatusId" :reduce="item => item.id"
								v-model="filter.documentStatusId" :filterable="true"
								@input="getWorkOrderSupplysWithoutLoading" @search="getDocumentStatuss"></v-select>
						</b-th>

						<b-th stacked-heading="Select All">
							<b-form-checkbox v-if="(userRole != null ? userRole.allowPrint : false)"
								id="input-select-all" class="float-right d-block d-md-none"
								v-model="selectAll"></b-form-checkbox>
						</b-th>
					</template>
					<template v-slot:cell(no)="row">
						{{ ((row.index + 1) + (pageSizeOptions * (currentPage - 1))) }}
					</template>

					<template v-slot:cell(workOrderSupplyNumber)="row">
						<a @click="() => ($router.push({ name: 'workordersupplydetail', params: { id: row.item.id } }))"
							class="a-link-detail">
							{{ row.item.workOrderSupplyNumber != null && row.item.workOrderSupplyNumber != "" ?
				row.item.workOrderSupplyNumber.slice(0, 30) + (row.item.workOrderSupplyNumber.length > 30 ?"..." : "")
				 : "" }}
						</a>
					</template>

					<template v-slot:cell(workOrderProcess)="row">
						{{ row.item.workOrderProcess != null ? row.item.workOrderProcess.workOrderProcessNumber : "" }}
					</template>
					<template v-slot:cell(workOrderSupplyDate)="row">
						{{ row.item.workOrderSupplyDate | moment("DD-MMM-YYYY") }}
					</template>
					<template v-slot:cell(remark)="row">
						<app-long-text :id="'remark-' + row.index"
							:text="row.item != null ? (row.item.remark != null && row.item.remark != '' ? row.item.remark : '') : ''" />
					</template>
					<template v-slot:cell(line)="row">
						{{ row.item.line != null ? row.item.line.code : "" }}
					</template>
					<template v-slot:cell(documentStatus)="row">
						<!-- {{ row.item.documentStatus != null ? row.item.documentStatus.name : "" }} -->
						<div :id="getDocumentStatus(row.item.documentStatus.name)">
						</div>
					</template>

					<template v-slot:cell(front-action)="row">
						<div class="d-flex justify-content-center ml-2">
							<b-form-checkbox :id="'input-is-checked-' + (row.index + 1)"
								@change="toggleSelect(Number(row.item.id))"
								:checked="checkAllData.includes(Number(row.item.id))"></b-form-checkbox>
						</div>
					</template>
					<template v-slot:cell(actions)="row">
						<span>
							<b-button size="sm" @click="row.toggleDetails" class="mr-2 btn-sm btn-transparent border-0">
								<b-icon-chevron-down v-if="!row.detailsShowing"></b-icon-chevron-down>
								<b-icon-chevron-up v-else></b-icon-chevron-up>
							</b-button>
						</span>
					</template>
					<template #row-details="row">
						<b-card>
							<app-input-datepicker id="fieldset-work-order-supply-date" label-cols-lg="12"
								label="WorkOrderSupplyDate" size="sm" :model.sync="row.item.workOrderSupplyDate"
								:date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
								locale="en-GB" :isEditable="false" :isUpdatable="true" />
							<app-input-textarea id="fieldset-remark" label-cols-lg="12" label="Remark"
								label-for="input-remark" size="sm" :model.sync="row.item.remark" :isEditable="false"
								:isUpdatable="true" />
							<app-input-combobox optionsLabel="code" label-cols-sm="12" :model="row.item.lineId"
								label="Line" :selected="row.item.line != null ? row.item.line.code : ''"
								:isEditable="false" :isUpdatable="true" />
							<app-input-combobox optionsLabel="name" label-cols-sm="12"
								:model="row.item.documentStatusId" label="Document Status"
								:selected="row.item.documentStatus != null ? row.item.documentStatus.name : ''"
								:isEditable="false" :isUpdatable="true" />

						</b-card>
					</template>
				</b-table>
			</div>
			<b-row>
				<b-col cols="12" class="paging-container">
					<div>
						<b-row>
							<b-col cols="12">
								<b-pagination class="btn-paging paging-page-size" v-model="currentPage"
									:total-rows="(workOrderSupplysPaging != null ? workOrderSupplysPaging.dataCount : 0)"
									:per-page="(workOrderSupplysPaging != null ? workOrderSupplysPaging.pageSize : 0)"
									aria-controls="my-table">
									<template #first-text>
										<b-icon-chevron-left />
									</template>
									<template #prev-text>
										Prev
									</template>
									<template #next-text>
										Next
									</template>
									<template #last-text>
										<b-icon-chevron-right />
									</template>
								</b-pagination>
								<span class="paging-page-size">
									<b-form-select v-if="false" v-model="pageSizeOptions" size="sm" class="float-right"
										:options="pagingOptions"></b-form-select>
									<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size"
										size="sm">
										<b-dropdown-item v-for="item in pagingOptions" :key="item.value"
											@click="pageSizeOptions = item.value">
											{{ item.text }}
										</b-dropdown-item>
									</b-dropdown>
								</span>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</div>
		<Upload :openPopup="showPopupUpload" @resetMethod="resetModalUpload" @uploadButtonMethod="uploadData" />
		<PopupDownload :openPopup="showPopupDownload" :processId="processId" @resetModalMethod="resetModal"
			label="Popup Download" :contentLabel="popupDownloadLabel" />
		<PopupPDF :openPopup="isShowPopupPDF" :pdfUrl="pdfUrl" @resetModalMethod="resetModal" label="Popup PDF" />
		<PopupDataEditNotification entityName="approvalconfiguration" :dataId="currentDataId"
			@resetModalMethod="resetModal" label="Data Recovery" />
		<RouterView />
	</div>
</template>
<style lang="scss" scoped>
@import '../../assets/scss/index-page.scss';

::v-deep #table-list-workordersupply.b-table.b-table-stacked>tbody>tr>td.th-front-action::before {
	background-image: url(/img/box-checklist.png);
	background-size: 40px 40px;
	display: block;
	width: 40px;
	height: 40px;
	content: "";
	margin-bottom: 10px;
}

::v-deep #table-list-workordersupply.b-table>thead>tr>th {
	background: #e28b29;
}

::v-deep #table-list-workordersupply.b-table.b-table-stacked>tbody>tr>td.th-front-action>div {
	display: flex;
}

#box-green {
	width: 30px;
	height: 30px;
	background-color: green;
}

#box-yellow {
	width: 30px;
	height: 30px;
	background-color: yellow;
}

#box-red {
	width: 30px;
	height: 30px;
	background-color: red;
}
</style>
<script>
import WorkOrderSupply from '@/models/WorkOrderSupply/WorkOrderSupply';
import WorkOrderSupplyList from '@/models/WorkOrderSupply/WorkOrderSupplyList';
import WorkOrderSupplyFilter from '@/filters/WorkOrderSupply/WorkOrderSupplyFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputCombobox from '@/components/AppInputCombobox';
import AppInputTextarea from '@/components/AppInputTextarea';
import WorkOrderProcessFilter from '@/filters/WorkOrderProcess/WorkOrderProcessFilter';
import WorkOrderProcess from '@/models/WorkOrderProcess/WorkOrderProcess';
import AppLabel from '@/components/AppLabel';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import LineFilter from '@/filters/Line/LineFilter';
import Line from '@/models/Line/Line';
import DocumentStatusFilter from '@/filters/DocumentStatus/DocumentStatusFilter';
import DocumentStatus from '@/models/DocumentStatus/DocumentStatus';
import PartFilter from '@/filters/Part/PartFilter';
import Part from '@/models/Part/Part';
import WorkOrderProcessDetailFilter from '@/filters/WorkOrderProcess/WorkOrderProcessDetailFilter';
import WorkOrderProcessDetail from '@/models/WorkOrderProcess/WorkOrderProcessDetail';
import BillOfMaterialDetailFilter from '@/filters/BillOfMaterial/BillOfMaterialDetailFilter';
import BillOfMaterialDetail from '@/models/BillOfMaterial/BillOfMaterialDetail';
import CustomerFilter from '@/filters/Customer/CustomerFilter';
import Customer from '@/models/Customer/Customer';
import UomFilter from '@/filters/Uom/UomFilter';
import Uom from '@/models/Uom/Uom';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
import Upload from './Upload';
import AppInputTextbox from '@/components/AppInputTextbox';

export default {
	components: {
		WorkOrderSupply,
		WorkOrderSupplyList,
		WorkOrderSupplyFilter,
		AppInputTextarea,
		AppInputComboboxAutocomplete,
		AppInputCombobox,
		AppLabel,
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputTextarea,
		PopupDownload,
		PopupPDF,
		Upload,
		PopupDataEditNotification,
		AppInputTextbox
	},
	data() {
		return {
			selectAll: false,
			sortBy: '',
			sortDesc: '',
			pagingOptions: [
				{ value: '10', text: '10', selected: true },
				{ value: '25', text: '25' },
				{ value: '50', text: '50' },
				{ value: '100', text: '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData: 0,
			fields: [
				{ "front-action": { "class": "th-front-action", "label": "" } },
				{ "no": { "class": "th-number d-stack-none" } },
				{ "workOrderProcess": {}, "class": "th-work-order-process first-child", "label": "Work Order Process Number", key: 'workOrderProcess', sortable: true },
				{ "workOrderSupplyNumber": {}, "class": "th-work-order-supply-number", "label": "Work Order Supply Number", key: 'workOrderSupplyNumber', sortable: true },
				{ "workOrderSupplyDate": {}, "class": "th-work-order-supply-date last-child", "label": "Work Order Supply Date", key: 'workOrderSupplyDate', sortable: true },
				{ "remark": {}, "class": "th-remark d-stack-none", "label": "Remark", key: 'remark', sortable: true },
				{ "line": {}, "class": "th-line d-stack-none", "label": "Line", key: 'line', sortable: true },
				{ "documentStatus": {}, "class": "th-document-status d-stack-none", "label": "Document Status", key: 'documentStatus', sortable: true },

				{ "actions": { "class": "th-actions d-stack-show", "label": "" } }
			],
			yesNoCombo: [
				{ id: 'TRUE', name: 'True', selected: true },
				{ id: 'FALSE', name: 'False' },
			],
			busy: false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected: '',
			pageSizeOptions: 10,
			pageIndex: 0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			selectedModel: null,
			workOrderSupplys: [],
			workOrderSupplysPaging: {},
			workOrderProcesss: [],
			lines: [],
			documentStatuss: [],
			workOrderSupplyDetails: [],

			isApprovalBusy: false,
			isFilterShow: false,
			isDeleteBusy: false,
			isPullRight: false,
			isPullLeft: true,
			isStacked: false,
			isScannerMode: false,
			disableFeature: false,
		}
	},
	methods: {
		getDocumentStatus(status) {
			switch (status) {
				case 'OPEN':
					return 'box-red';
				case 'IN_PROGRESS':
					return 'box-yellow';
				case 'CLOSED':
					return 'box-green';
				default:
					return '';
			}
		},
		getWorkOrderSupplys: async function () {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			WorkOrderSupply.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
				.then(result => {
					if (result != null) {
						this.workOrderSupplys = result.data
						this.workOrderSupplysPaging = result
					}
					this.isDataLoading = false;
				})
				.catch(error => {
					this.isDataLoading = false;
				});
		},
		getWorkOrderSupplysWithoutLoading: async function () {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			WorkOrderSupply.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
				.then(result => {
					if (result != null) {
						this.workOrderSupplys = result.data
						this.workOrderSupplysPaging = result
					}
				})
				.catch(error => { });
		},
		getWorkOrderProcesss: async function (input) {
			let filter = new WorkOrderProcessFilter();
			if (input != undefined) {
				filter.workOrderProcessNumber = input;
			}
			if(this.filter.workOrderProcessId != undefined && input == '')
			{
				filter.id = this.filter.workOrderProcessId;
			}
			WorkOrderProcess.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.workOrderProcesss = result.data
					}
				})
				.catch(error => { });
		},
		getLines: async function (input) {
			let filter = new LineFilter();
			if (input != undefined) {
				filter.code = input;
			}
			if(this.filter.lineId != undefined && input == '')
			{
				filter.id = this.filter.lineId;
			}
			Line.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.lines = result.data
					}
				})
				.catch(error => { });
		},
		getDocumentStatuss: async function (input) {
			let filter = new DocumentStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			if(this.filter.documentStatusId != undefined && input == '')
			{
				filter.id = this.filter.documentStatusId;
			}
			DocumentStatus.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.documentStatuss = result.data
					}
				})
				.catch(error => { });
		},

		resetFilter() {
			this.filter = new WorkOrderSupplyFilter();
			this.getWorkOrderSupplys();
			this.isFilterShow = false;
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
			this.isFilterShow = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getWorkOrderSupplys();
		},
		toggleSelect(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				WorkOrderSupply.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
					this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			WorkOrderSupply.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			this.isDownloadDataBusy = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			WorkOrderSupply.downloadData(this, this.filter, this.sortingBy)
				.then(result => {
					if (result) {
						this.showPopupDownloadData(result.id);
					}
					this.isDownloadDataBusy = false;
				})
				.catch(error => {
					this.isDownloadDataBusy = false;
				})
		},
		createData() {
			this.isCreateBusy = true;
			WorkOrderSupply.createData(this).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						let createRoute = 'workordersupplyedit';
						if (this.isScannerMode) {
							createRoute = 'workordersupplyscan';
						}

						this.$router.push({ name: createRoute, params: { id: result.id } });
					}
				}
				this.isCreateBusy = false;
			}).catch(error => {
				this.isCreateBusy = false;
			})
		},
		editData(index, id) {
			this.btnEditData[index] = true;
			this.dataId = id;
			WorkOrderSupply.editData(this, id).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						this.$router.push({ name: 'workordersupplyedit', params: { id: result.id } });
					}
				}
				this.btnEditData[index] = false;
			}).catch(error => { this.btnEditData[index] = false; })
		},

		deleteData(id) {
			WorkOrderSupply.deleteData(this, id).then(result => {
				if (result) {
					this.getWorkOrderSupplys();
				}
			})
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				WorkOrderSupply.deleteMultipleData(this).then(result => {
					this.getWorkOrderSupplys();
					this.isDeleteBusy = false;
				}).catch(error => { this.isDeleteBusy = false; });
			}
		},
		onResize() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 576) {
				this.isStacked = true;
			} else {
				this.isStacked = false;
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},


		scrollRight() {
			var tableWorkOrderSupplyParent = document.getElementById('table-list-workordersupply').parentNode;
			tableWorkOrderSupplyParent.scrollLeft += 250;
			this.isPullLeft = false;
			this.isPullRight = false;
			if ((tableWorkOrderSupplyParent.scrollWidth - tableWorkOrderSupplyParent.offsetWidth) == Math.ceil(tableWorkOrderSupplyParent.scrollLeft)) {
				this.isPullRight = true;
			}
		},
		scrollLeft() {
			var tableWorkOrderSupplyParent = document.getElementById('table-list-workordersupply').parentNode;
			tableWorkOrderSupplyParent.scrollLeft -= 250;
			this.isPullRight = false;
			this.isPullLeft = false;
			if (tableWorkOrderSupplyParent.scrollLeft <= 0) {
				this.isPullLeft = true;
			}
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return
			if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		}
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new WorkOrderSupplyFilter();
		this.getWorkOrderProcesss()
		this.getLines()
		this.getDocumentStatuss()
	},
	mounted() {
		let breadcrumb = [
			"Master Data",
			"Work Order Supply"
		];
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.onResize();
		this.$nextTick(() => {
			this.getWorkOrderSupplys();
			window.addEventListener('resize', this.onResize);
		});
	}, watch: {
		sortBy: {
			handler: function () {
				this.getWorkOrderSupplys();
			}
		},
		sortDesc: {
			handler: function () {
				this.getWorkOrderSupplys();
			}
		},
		currentPage: {
			handler: function () {
				this.getWorkOrderSupplys();
			}
		},
		pageSizeOptions: {
			handler: function () {
				this.getWorkOrderSupplys();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				WorkOrderSupply.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "workordersupplyindex") {
					this.getWorkOrderSupplysWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "work_order_supply").first();
		},
		isShowDeleteButton: function () {
			let userRoleAllowDelete = true;
			if (this.userRole != null) {
				userRoleAllowDelete = this.userRole.allowDelete;
			}

			if (window.innerWidth <= 576) {
				if (userRoleAllowDelete) {
					if (this.checkAllData.length > 0) return true;
				}
				return false;
			}

			return userRoleAllowDelete;
		},
		isShowAdvanceFilterButton: function () {
			if (window.innerWidth <= 576) {
				if (this.checkAllData.length <= 0) return true;
				return false;
			}
			return true;
		}
	}, beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
